/**
 * React Query cache keys shared between modules.
 *
 * TASK-877: `GET /meeting` was measured at 8+ requests per page load, 11'865 bytes each.
 * `listMeetings` takes no arguments — there is exactly ONE resource behind it — but its
 * two consumers had each invented a key (`['live-meetings']` in `useLiveMeetingSurfacing`,
 * `['meetings-list']` in `MeetingsList`), so React Query held two caches and ran two
 * independent fetch streams over the same URL, one of them on a 20s poll.
 *
 * **Why a module of its own** rather than an export beside the fetcher, which is where
 * this first went: seven test files `vi.mock('…/meetingApi')` with a factory that lists
 * only the functions they use. A constant exported from there is `undefined` under those
 * mocks, and `useQuery({ queryKey: undefined })` throws — 78 tests failed on it. A cache
 * key is configuration, not an API method; nothing needs to stub it, so nothing does.
 */

/** The one key for `listMeetings` — argument-less, so one resource and one cache. */
export const MEETINGS_QUERY_KEY = ['meetings'] as const;
